import React, { Component, PropTypes } from 'react'
import classNames from 'classnames'
import BrandingLink from '../../BrandingLink'
import CTAButton from '../CTAButton'
import Well from '../Well'
import { THEME } from '../constants'
import styles from './style.styl'

/* Product Announcement takeover modal */
export default class ProductAnnouncement extends Component {
  onWheel = (e) => {
    const node = this.scrollNode
    if (!node) {
      return
    }

    if (e.deltaY < 0 && node.scrollTop === 0) {
      e.preventDefault()
    }
    if (e.deltaY > 0 &&
        (node.clientHeight + node.scrollTop + e.deltaY >= node.scrollHeight)) {
      node.scrollTop = node.scrollHeight
      e.preventDefault()
    }
  }

  renderCtaButton() {
    const {
      ctaCopy,
      ctaHref,
      onCtaClick,
      primaryColor,
      secondaryColor,
    } = this.props

    if (ctaCopy) {
      return (
        <CTAButton onClick={onCtaClick}
                   href={ctaHref}
                   primaryColor={primaryColor}
                   secondaryColor={secondaryColor}>
          {ctaCopy}
        </CTAButton>
      )
    }
  }

  render() {
    const {
      brandingContent,
      children,
      headline,
      primaryColor,
      showBranding,
      theme,
    } = this.props

    const themeClass = `theme-${theme.toLowerCase()}`
    const maybeFooterNode = showBranding
      ? (
        <div className={classNames(styles.Footer, 'flex-center')}>
          {brandingContent}
        </div>
      )
      : null

    return (
      <div>
        <div className={classNames(
               styles.ProductAnnouncementTakeover,
               'flex-column',
               themeClass
             )}>
          <h1 className={classNames(
                styles.Headline,
                'dsg-h1',
                'dsg-medium-weight',
                themeClass
              )}>
            {headline}
          </h1>
          <Well className={styles.Well}
                primaryColor={primaryColor}
                themeClass={themeClass}>
            <div ref={(c) => { this.scrollNode = c }}
              className={styles.ScrollableArea}
              onWheel={this.onWheel}>
              <div className={styles.Content}>
                <div className={styles.Message}>
                  {children}
                </div>
              </div>
            </div>
            {this.renderCtaButton()}
          </Well>
          {maybeFooterNode}
        </div>
      </div>
    )
  }
}

ProductAnnouncement.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.oneOf([THEME.LIGHT, THEME.DARK]),
  // Event handler for CTA button click event
  onCtaClick: PropTypes.func,
  // URL passed to CTA button as `href` property
  ctaHref: PropTypes.string,
  // Text content for CTA button
  ctaCopy: PropTypes.string,
  // Primary branding color
  primaryColor: PropTypes.string,
  // Secondary branding color
  secondaryColor: PropTypes.string,
  // Campaign's title text
  headline: PropTypes.string,
  // Specifies if the Drift Branding should be displayed
  showBranding: PropTypes.bool,
  // The content to include as the Drift Branding
  brandingContent: PropTypes.node,
}
ProductAnnouncement.defaultProps = {
  theme: THEME.LIGHT,
  showBranding: true,
  brandingContent: <BrandingLink size='medium'/>,
}



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/widget/TakeoverCampaign/ProductAnnouncement/index.js